import { jsx as _jsx } from "react/jsx-runtime";
const STATUS_CONFIG = {
    DRAFT: { bg: 'var(--color-surface-raised)', text: 'var(--color-text-muted)', label: 'Borrador' },
    CONFIRMED: { bg: 'var(--color-primary-100)', text: 'var(--color-primary-700)', label: 'Confirmado' },
    IN_PROGRESS: { bg: 'var(--color-warning-light)', text: 'var(--color-warning)', label: 'En Progreso' },
    COMPLETED: { bg: 'var(--color-success-light)', text: 'var(--color-success)', label: 'Completado' },
    CANCELLED: { bg: 'var(--color-error-light)', text: 'var(--color-error)', label: 'Cancelado' },
    WAITLIST: { bg: 'var(--color-warning-light)', text: 'var(--color-warning)', label: 'Lista de Espera' },
    NO_SHOW: { bg: 'var(--color-error-light)', text: 'var(--color-error)', label: 'No Presentó' },
};
export function StatusBadge({ status, className = '' }) {
    const config = STATUS_CONFIG[status] ?? {
        bg: 'var(--color-surface-raised)',
        text: 'var(--color-text-muted)',
        label: status,
    };
    return (_jsx("span", { className: `badge ${className}`, style: {
            backgroundColor: config.bg,
            color: config.text,
        }, children: config.label }));
}
//# sourceMappingURL=StatusBadge.js.map